module.exports = __webpack_public_path__ + "static/media/logo-chilim-balam.443dcd2b.JPG";